// packages
import { ShieldOff, Search, LogIn, PieChart, Network, Home as HomeIcon, ClipboardList, FileSpreadsheet, Lock, Stethoscope, FlaskConical } from 'lucide-react'

// types
import { RouteProps } from '@/types/routes-types'

// entities
import { UserProps, user_role } from '@/entities/user'

// store
import { useAuthStore } from '@/store/auth'

export const checkRoutePermission = (user: UserProps | null, roles: user_role[]) => {
  if (user) return roles?.includes(user?.role)
  else {
    const storeUser = useAuthStore.getState().user
    return roles?.includes(storeUser?.role)
  }
}

// pages
import NotFound from '@/pages/NotFound'
import Login from '@/pages/Login'
import Dashboard from '@/pages/Dashboard'
import Chat from '@/pages/Chat'
import UserManagement from '@/pages/Users'
import Anamnesis from '@/pages/Anamnesis'
// import ExamConsultant from '@/pages/ExamConsultant' // desativado temporariamente
import ExamLibrary from '@/pages/ExamLibrary'
import Home from '@/pages/site/Home'
import Register from '@/pages/Register'
import ForgotPassword from '@/pages/ForgotPassword'
import { ResetPassword } from '@/pages/ResetPassword'
import SignsSymptoms from '@/pages/SignsSymptoms'
import SignsSymptomsForm from '@/pages/SignsSymptomsForm'
import ExamAnalysis from '@/pages/ExamAnalysis'
import ExamAnalysisForm from '@/pages/ExamAnalysisForm'

export const externalRoutes = ['/', '/login', '/400', '/401', '/403', '/404', '/500', '/register', '/reset-password', '/reset-password/', '/forgot-password']
const dynamicRoutePatterns = [/^\/reset-password(\/[^\/]+)?$/]

export const isExternalRoutes = (path: string) => {
  if (externalRoutes.includes(path)) return true
  return dynamicRoutePatterns.some(pattern => pattern.test(path))
}

export const routes: RouteProps[] = [
  /*   {
    name: '401',
    path: '/401',
    icon: ShieldOff,
    component: Unauthorized,
    disabled: () => true,
    showOnSidebar: () => false,
  }, */
  {
    name: 'Login',
    path: '/',
    icon: LogIn,
    component: Login,
    disabled: () => true,
    showOnSidebar: () => false
  },
  {
    name: '404',
    path: '/404',
    icon: Search,
    component: NotFound,
    disabled: () => true,
    showOnSidebar: () => false
  },
  {
    name: 'Login',
    path: '/login',
    icon: LogIn,
    component: Login,
    disabled: () => false,
    showOnSidebar: () => false
  },
  {
    name: 'Cadastro',
    path: '/register',
    icon: Network,
    component: Register,
    disabled: () => false,
    showOnSidebar: () => false
  },
  {
    name: 'Redefinir senha',
    path: '/forgot-password',
    icon: Lock,
    component: ForgotPassword,
    disabled: () => false,
    showOnSidebar: () => false
  },
  {
    name: 'Redefinir senha',
    path: '/reset-password',
    icon: Lock,
    component: ResetPassword,
    disabled: () => false,
    showOnSidebar: () => false
  },
  {
    name: 'Redefinir senha',
    path: '/reset-password/:code',
    icon: Lock,
    component: ResetPassword,
    disabled: () => false,
    showOnSidebar: () => false
  },
  {
    name: 'Chat',
    path: '/chat',
    icon: HomeIcon,
    group: 'Chat',
    component: Chat,
    description: ``,
    category: 'page',
    roles: [user_role.ADMIN, user_role.CUSTOMER, user_role.MODERATOR],
    disabled: () => false,
    showOnSidebar: () => false
  },
  {
    name: 'Chat ....',
    path: '/chat/:ref',
    icon: Network,
    group: 'Chat',
    category: 'chat',
    component: Chat,
    description: ``,
    roles: [user_role.ADMIN, user_role.CUSTOMER, user_role.MODERATOR],
    disabled: () => false,
    showOnSidebar: () => false
  },
  {
    name: 'Usuários',
    path: '/users',
    icon: Network,
    group: 'Register',
    category: 'register',
    component: UserManagement,
    description: ``,
    roles: [user_role.ADMIN, user_role.MODERATOR],
    disabled: () => false,
    showOnSidebar: () => true
  },
  {
    name: 'Dashboard',
    path: '/dashboard',
    icon: PieChart,
    group: 'Controle',
    category: 'page',
    roles: [user_role.ADMIN, user_role.MODERATOR],
    component: Dashboard,
    disabled: () => false,
    showOnSidebar: () => true
  },
  // Consultor de Exames desativado temporariamente — rota removida para bloquear acesso direto por URL.
  /* {
    name: 'Consultor de Exames',
    path: '/exam-consultant',
    icon: Microscope,
    group: 'Tool',
    category: 'tool',
    component: ExamConsultant,
    description: ``,
    roles: [user_role.ADMIN, user_role.MODERATOR, user_role.CUSTOMER],
    disabled: () => false,
    showOnSidebar: () => true
  }, */
  {
    name: 'Modelos de Anamnese',
    path: '/anamnesis',
    icon: ClipboardList,
    group: 'Tool',
    category: 'tool',
    component: Anamnesis,
    description: ``,
    roles: [user_role.ADMIN, user_role.MODERATOR, user_role.CUSTOMER],
    disabled: () => false,
    showOnSidebar: () => true
  },
  {
    name: 'Sinais e Sintomas',
    path: '/signs-symptoms',
    icon: Stethoscope,
    group: 'Tool',
    category: 'tool',
    component: SignsSymptoms,
    description: ``,
    roles: [user_role.ADMIN, user_role.MODERATOR, user_role.CUSTOMER],
    disabled: () => false,
    showOnSidebar: () => true
  },
  {
    name: 'Sinais e Sintomas — Formulário',
    path: '/signs-symptoms/new',
    icon: Stethoscope,
    group: 'Tool',
    category: 'tool',
    component: SignsSymptomsForm,
    description: ``,
    roles: [user_role.ADMIN, user_role.MODERATOR, user_role.CUSTOMER],
    disabled: () => false,
    showOnSidebar: () => false
  },
  {
    name: 'Sinais e Sintomas — Editar',
    path: '/signs-symptoms/:ref',
    icon: Stethoscope,
    group: 'Tool',
    category: 'tool',
    component: SignsSymptomsForm,
    description: ``,
    roles: [user_role.ADMIN, user_role.MODERATOR, user_role.CUSTOMER],
    disabled: () => false,
    showOnSidebar: () => false
  },
  {
    name: 'Análise de Exames',
    path: '/exam-analysis',
    icon: FlaskConical,
    group: 'Tool',
    category: 'tool',
    component: ExamAnalysis,
    description: ``,
    roles: [user_role.ADMIN, user_role.MODERATOR, user_role.CUSTOMER],
    disabled: () => false,
    showOnSidebar: () => true
  },
  {
    name: 'Análise de Exames — Novo',
    path: '/exam-analysis/new',
    icon: FlaskConical,
    group: 'Tool',
    category: 'tool',
    component: ExamAnalysisForm,
    description: ``,
    roles: [user_role.ADMIN, user_role.MODERATOR, user_role.CUSTOMER],
    disabled: () => false,
    showOnSidebar: () => false
  },
  {
    name: 'Análise de Exames — Editar',
    path: '/exam-analysis/:ref',
    icon: FlaskConical,
    group: 'Tool',
    category: 'tool',
    component: ExamAnalysisForm,
    description: ``,
    roles: [user_role.ADMIN, user_role.MODERATOR, user_role.CUSTOMER],
    disabled: () => false,
    showOnSidebar: () => false
  },
  {
    name: 'Exames Recomendados',
    path: '/exam-library',
    icon: FileSpreadsheet,
    group: 'Tool',
    category: 'tool',
    component: ExamLibrary,
    description: ``,
    roles: [user_role.ADMIN, user_role.MODERATOR, user_role.CUSTOMER],
    disabled: () => false,
    showOnSidebar: () => true
  }
]
